<template>
  <div class="favorite-filter">
    <FiltersActiveFilters
      v-if="showActive"
      :list="activeList"
      @cancel="(e) => $emit('cancel', e)"
      @clear-all="$emit('clearAll')"
    />
    <template
      v-if="
        categorySettings.allowed_values &&
        categorySettings.allowed_values.length > 1
      "
    >
      <div class="title body-m-semibold">Категория товаров</div>

      <div class="categories">
        <EnumFilter
          :settings="categorySettings"
          :value="filters.categories"
          @on-change="selectCategory"
        />
      </div>
    </template>

    <BooleanFilter
      class="available"
      :settings="{ name: 'Показывать только товары в наличии' }"
      :value="filters.available"
      @on-change="toggleProductAvailability"
    />
  </div>
</template>

<script setup lang="ts">
import BooleanFilter from '@/components/filters/boolean-filter/boolean-filter.vue';
import EnumFilter from '@/components/filters/enum-filter-listings/enum-filter-listings.vue';
import type {
  FiltersChangeArguments,
  ActiveFilter,
  FavoriteCategories,
  FavoriteFilters,
} from '@/interfaces/app';

const props = defineProps({
  categories: {
    type: Object as () => FavoriteCategories,
    required: true,
  },
  filters: {
    type: Object as () => FavoriteFilters,
    required: true,
  },
  showActive: {
    type: Boolean,
    default: false,
  },
  activeList: {
    type: Array as () => ActiveFilter[],
    default: () => [],
  },
});

const emit = defineEmits([
  'update-categories',
  'update-availability',
  'cancel',
  'clearAll',
]);
const categorySettings = computed(() => {
  return {
    allowed_values: Object.keys(props.categories).map((key) => ({
      id: +key,
      name: props.categories[+key],
      slug: true,
    })),
  };
});

function selectCategory({ val, queryVal }: FiltersChangeArguments) {
  emit('update-categories', { val, queryVal });
}

function toggleProductAvailability({ val, queryVal }: FiltersChangeArguments) {
  emit('update-availability', { val, queryVal });
}
</script>
<style lang="scss" scoped>
.favorite-filter {
  width: 100%;

  .active-filters {
    padding-top: 8px;

    & + .title {
      padding-top: 24px;
    }
  }

  .title {
    padding-bottom: 16px;
    padding-top: 48px;

    @include lg-block {
      padding-top: 24px;
    }
  }

  .categories {
    padding-bottom: 24px;
    border-bottom: 1px solid $achromatic-hover;
  }

  .available {
    margin-top: 24px;
  }
}
</style>
